import * as moment from "moment";

export enum TAGS_TABLE_COLUMNS {
    CODE = 'Code',
    DESCRIPTION = 'Description',
    ACTIONS = 'Actions',
    RULES = 'Rules',
    EVENTS = 'Events',
}
export const TAGS_DEFAULT_START = moment().format('yyyy-MM-DDT00:00');
export const TAGS_DEFAULT_END = moment().add(7, 'days').format('yyyy-MM-DDT00:00');

export const TAGS_DEFAULT_SORT_COLUMN = TAGS_TABLE_COLUMNS.CODE;
export const TAGS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const TAGS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const TAGS_PAGE_DEFAULT_SIZE = 10;
export const TAGS_MAX_MEMORY_SIZE = 3000;

export const TAGS_TABLE_HEADER = [
    TAGS_TABLE_COLUMNS.CODE,
    TAGS_TABLE_COLUMNS.DESCRIPTION,
    TAGS_TABLE_COLUMNS.ACTIONS,
    TAGS_TABLE_COLUMNS.RULES,
    TAGS_TABLE_COLUMNS.EVENTS,
];

export const MTMACSTD_MINFWVER_QUICKEASY_TAGS = '1.11.000';
export const MTMACUS_MINFWVER_QUICKEASY_TAGS = '0.04.002';